module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_8003.01bb44f3.png";